export const UPDATE_TITLE = 'UPDATE_TITLE';

export function updateTitle(title, subTitle) {
    return {
        type: UPDATE_TITLE,
        payload: {
            title,
            subTitle
        }
    };
}



// WEBPACK FOOTER //
// ./components/page-header/page-header-actions.js